import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "w-full flex border-y"
};
const _hoisted_2 = {
  class: "grow flex items-center justify-center"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode("--");
const _hoisted_4 = {
  class: "child:m-1 flex"
};
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    modelValue: null,
    pageCount: null
  },
  emits: ['update', 'update:modelValue'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const onClickPrev = () => emit('update:modelValue', props.modelValue - 1);
    const onClickNext = () => emit('update:modelValue', props.modelValue + 1);
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "display", {}, () => [__props.pageCount === 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_hoisted_3], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createTextVNode(_toDisplayString(__props.modelValue) + " / " + _toDisplayString(__props.pageCount), 1)], 64))])]), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "controls")]), _createVNode(_component_NButton, {
        secondary: "",
        disabled: __props.modelValue === 1,
        class: "w-16 m-1",
        onClick: onClickPrev
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.ChevronLeftFilled
        }, null, 8, ["icon"])]),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_NButton, {
        secondary: "",
        disabled: __props.modelValue >= __props.pageCount,
        class: "w-16 m-1",
        onClick: onClickNext
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.ChevronRightFilled
        }, null, 8, ["icon"])]),
        _: 1
      }, 8, ["disabled"])]);
    };
  }
});